module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/area_yokohama-76226391049722e571b87ae74682add2.jpg";